/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Side_RightInputs */

const en_us2_workout_logging_side_right = /** @type {(inputs: Workout_Logging_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right`)
};

const pt_br2_workout_logging_side_right = /** @type {(inputs: Workout_Logging_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direita`)
};

const es_419_workout_logging_side_right = /** @type {(inputs: Workout_Logging_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho`)
};

const pt_pt2_workout_logging_side_right = /** @type {(inputs: Workout_Logging_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direito`)
};

const fr_fr2_workout_logging_side_right = /** @type {(inputs: Workout_Logging_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droite`)
};

const de_de2_workout_logging_side_right = /** @type {(inputs: Workout_Logging_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechts`)
};

const it_it2_workout_logging_side_right = /** @type {(inputs: Workout_Logging_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destro`)
};

/**
* | output |
* | --- |
* | "Right" |
*
* @param {Workout_Logging_Side_RightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_side_right = /** @type {((inputs?: Workout_Logging_Side_RightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Side_RightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_side_right(inputs)
	if (locale === "es-419") return es_419_workout_logging_side_right(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_side_right(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_side_right(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_side_right(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_side_right(inputs)
	return en_us2_workout_logging_side_right(inputs)
});
export { workout_logging_side_right as "workout-logging.side_right" }